// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ib-0";